import { createContext } from 'react';

export default createContext({
    isAuthenticated: false,
    loading: true,
    setStatus: () => {},
    setUser: () => {},
});